import {Service} from '../../utils/Service';

export default{
    queryBusShopUserVoBypage(data) {  //查询员工
          return Service({
            url: 'operationApi/busShopUserApi/queryBusShopUserVoBypage',
            data,
            method: 'POST' ,
          })
    },
    
    addBusShopUser(data) {  //添加员工
        return Service({
          url: 'operationApi/busShopUserApi/addBusShopUser',
          data,
          method: 'POST'
        })
    },
    updateBusShopUserByGuid(data) {  //修改员工
      return Service({
        url: 'operationApi/busShopUserApi/updateBusShopUserByGuid',
        data,
        method: 'POST'
      })
    },
    deleBusShopUserByGuid(data) { //删除员工
      return Service({
        url: 'operationApi/busShopUserApi/deleBusShopUserByGuid',
        data,
        method: 'POST'
      })
    },
    queryListBm(data) {
      return Service({
        url: 'managerApi/systemDepartapi/selectParentByTree',
        data,
        method: 'POST'
      })
    },
    jsQueryAll(data) {
      return Service({
        url: 'managerApi/systemRoleapi/listRoleOptions',
        data,
        method: 'POST'
      })
    },
    resettingBusShopUserPassword(data) {
      return Service({
        url: 'operationApi/busShopUserApi/resettingBusShopUserPassword',
        data,
        method: 'POST'
      })
    },
    addBusShopUserMapList(data) { //员工绑定店铺
      return Service({
        url: 'operationApi/busShopUserMapApi/addBusShopUserMapList',
        data,
        method: 'POST'
      })
    }
} 


// WEBPACK FOOTER //
// ./src/api/orgStaffManage/orgStaff.js